// // =============================
// // Header.jsx — Main Site Header (Updated)
// // =============================

// import React from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import { useProject } from "../ProjectContext";
// import logo from "../assets/logo.svg";
// import "../styles/Header.css";

// const Header = () => {
//   const { user, logout } = useAuth();
//   const { activeProject } = useProject();
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Handles logout and returns to home
//   const handleLogout = () => {
//     logout();
//     navigate("/");
//   };

//   return (
//     <header className="header">
//       {/* Left: Logo & App Name */}
//       <Link to="/" className="header-left">
//         <img src={logo} alt="Logo" className="logo" />
//         <span className="site-title">MAGICS</span>
//       </Link>

//       {/* Center: Main Navigation (Workflow links removed - now in sidebar) */}
//       <nav className="nav-options">
//         <Link to="/">Home</Link>
//         {user && <Link to="/dashboard">Dashboard</Link>}
//       </nav>

//       {/* Right: Project info and auth */}
//       <div className="header-right">
//         {user && activeProject && (
//           <span className="project-indicator">
//             Project:&nbsp;
//             <strong>{activeProject.name}</strong>
//           </span>
//         )}
//         {user ? (
//           <>
//             <span className="username">Hello, <strong>{user}</strong></span>
//             <button className="logout-button" onClick={handleLogout}>
//               Log Out
//             </button>
//           </>
//         ) : (
//           location.pathname !== "/login" && (
//             <Link to="/login">
//               <button className="login-button">Log In</button>
//             </Link>
//           )
//         )}
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "../assets/logo.svg"; 
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useProject } from "../ProjectContext";


const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const { activeProject } = useProject();
  const navigate = useNavigate();
  const location = useLocation();
  // Mock data for demo
    const handleLogout = () => {
    logout();
    navigate("/");
  };
  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <header className="bg-[#e7e7e7] shadow-[0_2px_6px_rgba(0,0,0,0.25)]">
        <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-12 py-5 lg:py-6 w-full">
          <div className="flex items-center justify-between gap-4">
            {/* Logo & Brand */}
            <a href="/" className="flex items-center gap-2 sm:gap-3 no-underline flex-shrink-0">
              <img src={Logo} alt="MAGICS Logo" className="h-8 w-8 sm:h-10 sm:w-10" />
              <span className="text-xl sm:text-2xl font-bold text-[#f53838] whitespace-nowrap">
                MAGICS
              </span>
            </a>

            {/* Desktop Navigation - Center */}
            {/* <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
              <a 
                href="/" 
                className="text-[#333] font-medium text-lg no-underline hover:text-[#f53838] transition-colors whitespace-nowrap"
              >
                Home
              </a>
              {user && (
                <a 
                  href="/dashboard" 
                  className="text-[#333] font-medium text-lg no-underline hover:text-[#f53838] transition-colors whitespace-nowrap"
                >
                  Dashboard
                </a>
              )}
            </nav> */}

            {/* Desktop Right Section */}
            <div className="hidden lg:flex items-center gap-3 xl:gap-4 flex-shrink-0">
              {user && activeProject && (
                <span className="text-sm xl:text-[15px] text-[#444] whitespace-nowrap">
                  Project: <strong>{activeProject.name}</strong>
                </span>
              )}
              {user ? (
                <>
                  <span className="text-sm text-[#333] whitespace-nowrap">
                    Hello, <strong>{user}</strong>
                  </span>
                  <button 
                    className="px-4 py-2 border border-[#d40000] bg-transparent text-[#d40000] rounded-lg font-medium hover:bg-[#ffeaea] transition-all whitespace-nowrap"
                    onClick={handleLogout}
                  >
                    Log Out
                  </button>
                </>
              ) : (
                location.pathname !== "/login" && (
                  <a href="/login">
                    <button 
                    className="px-4 py-2 border border-[#007bff] bg-transparent text-[#007bff] rounded-lg font-medium hover:bg-[#e6f0ff] transition-all whitespace-nowrap"
                      onClick={handleLogin}>
                      Log In
                    </button>
                  </a>
                )
              )}
            </div>

            {/* Mobile/Tablet Menu Button */}
            <button
              className="lg:hidden p-2 text-[#333] hover:text-[#f53838] transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-[999] lg:hidden"
            onClick={() => setMobileMenuOpen(false)}
          />
          
          {/* Slide-out Menu */}
          <div className="fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-[1000] lg:hidden">
            <div className="p-6">
              {/* Close Button */}
              <button
                className="absolute top-4 right-4 p-2 text-[#333] hover:text-[#f53838] transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <X size={24} />
              </button>

              {/* User Info */}
              {user && (
                <div className="mb-6 pt-8 pb-4 border-b border-gray-200">
                  <p className="text-lg font-semibold text-[#333]">Hello, {user}</p>
                  {activeProject && (
                    <p className="text-sm text-[#444] mt-2">
                      Project: <strong>{activeProject.name}</strong>
                    </p>
                  )}
                </div>
              )}

              {/* Navigation Links */}
              <nav className="flex flex-col gap-1">
                <a 
                  href="/" 
                  className="text-[#333] font-medium text-lg no-underline hover:bg-gray-100 px-4 py-3 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </a>
                {user && (
                  <a 
                    href="/project" 
                    className="text-[#333] font-medium text-lg no-underline hover:bg-gray-100 px-4 py-3 rounded-lg transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Dashboard
                  </a>
                )}
              </nav>

              {/* Auth Buttons */}
              <div className="mt-8">
                {user ? (
                  <button 
                    className="w-full px-4 py-3 border-2 border-[#d40000] bg-transparent text-[#d40000] rounded-lg font-semibold hover:bg-[#ffeaea] transition-all"
                    onClick={handleLogout}
                  >
                    Log Out
                  </button>
                ) : (
                  location.pathname !== "/login" && (
                    <a href="/login" onClick={() => setMobileMenuOpen(false)}>
                      <button className="w-full px-4 py-3 border-2 border-[#007bff] bg-transparent text-[#007bff] rounded-lg font-semibold hover:bg-[#e6f0ff] transition-all">
                        Log In
                      </button>
                    </a>
                  )
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;